var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "#AAAAAA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESK - TOP UP - ADD MONEY - FIAT PAGE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1557,
    transform: "translate(-420 -642)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 758532543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 758532541",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 112,
    transform: "translate(-16 -25)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/user-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/user-edit_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31 5.1665C23.87 5.1665 18.0834 10.9532 18.0834 18.0832C18.0834 25.2132 23.87 30.9998 31 30.9998C38.13 30.9998 43.9167 25.2132 43.9167 18.0832C43.9167 10.9532 38.13 5.1665 31 5.1665ZM36.6059 16.8173L29.6309 23.7923C29.3725 24.0507 28.83 24.309 28.4684 24.3865L25.8075 24.7482C24.8259 24.8773 24.1542 24.2057 24.3092 23.2498L24.6967 20.589C24.7484 20.2273 25.0067 19.6848 25.2909 19.4265L32.2659 12.4515C33.4542 11.2632 34.875 10.6948 36.6317 12.4515C38.3625 14.234 37.7942 15.629 36.6059 16.8173Z",
    fill: "#FFD427"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31 36.1665C18.0575 36.1665 7.51746 44.8465 7.51746 55.5415C7.51746 56.2648 8.08579 56.8332 8.80912 56.8332H53.1908C53.9141 56.8332 54.4825 56.2648 54.4825 55.5415C54.4825 44.8465 43.9425 36.1665 31 36.1665Z",
    fill: "#FFD427"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -26,
    y: -31,
    width: 213,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.d1a98b3ead4ec55652170e4ebf63081f.svg";
export { ForwardRef as ReactComponent };